/* Aura publish P1 — the REAL network deps for the voice batch-publish flow.
 * Kept separate from useBatchPublishVoice so tests inject fakes (options seam). */
import { listConnections } from '@/data/connections';
import { getBatchCandidates, confirmBatch, revertPublication, proposeUpdateLive, executeUpdateLive, undoUpdateLive } from '@/data/publishBatches';
import { batchSiteOptions } from './batchPublishModel.ts';
import type { BatchPublishDeps } from './useBatchPublishVoice.ts';

export const defaultBatchPublishDeps: BatchPublishDeps = {
  async listSites() {
    return batchSiteOptions(await listConnections());
  },
  async candidates(targetId, limit, draftIds) {
    return getBatchCandidates(targetId, limit, undefined, draftIds);
  },
  async confirm(targetId, draftIds, mode, channel, onReadback) {
    return confirmBatch(targetId, draftIds, mode, channel, onReadback);
  },
  async revert(publicationId) {
    return revertPublication(publicationId);
  },
  // Connector 1.3.0 update_live (owner GO 12-10-2026 15:53 UTC, option A).
  async proposeUpdateLive(targetId, draftId, channel) {
    return proposeUpdateLive(targetId, draftId, channel);
  },
  async executeUpdateLive(proposal) {
    return executeUpdateLive(proposal);
  },
  async undoUpdateLive(batchId) {
    return undoUpdateLive(batchId);
  },
};
